export default "__VITE_ASSET__DVvAUQ$I__"